export default function SectionHeader({
  label,
  title,
  description,
  align = 'left',
  light = false,
  creative = false,
}) {
  const mods = [
    'section-header',
    `section-header--${align}`,
    light ? ' section-header--light' : '',
    creative ? ' section-header--creative' : '',
  ].join('');

  return (
    <header className={mods}>
      {label && <p className="section-header__label">{label}</p>}
      {title && <h2 className="section-header__title">{title}</h2>}
      {description && <p className="section-header__desc">{description}</p>}
    </header>
  );
}
